<div class="new-container">
  <div style="width: 50%;">
    <div class="loading-text" *ngIf="noNomineeAdded">
      <!-- //*ngIf="noNomineeAdded" -->
      <div class="baner-container">
        <div class="row">
          <img src="../../../../assets/images/alert-triangle.png" alt="">
          <div class="col">
            <div class="head">Add Nominee</div>
            <div class="desc">Your policy is incomplete. Add nominee details now to safeguard your family during
              unforeseen events.</div>
          </div>
        </div>
      </div>

      <div>
        <button class="add-nominee-button" (click)="redirectToAddNominee()">Add Nominee</button>
      </div>
    </div>
    <div class="profile-container">
      <div class="upper-container">
        <div class="top-bar">
          <div class="top-bar-left">
            <img src="../../../../assets/images/healthInsuranceIcon.png" alt="">
          </div>
          <div class="top-bar-center">
            <div class="name" *ngIf="memberSelf.insuredName"> {{memberSelf.insuredName}}</div>
            <div class="name skel" *ngIf="!memberSelf.insuredName"> </div>
            <div class="uhid" *ngIf="memberSelf.uhid">UHID: {{memberSelf.uhid}}</div>
            <div class="uhid skel" *ngIf="!memberSelf.uhid"></div>
          </div>
          <div class="top-bar-right">
            <img src="../../../../assets/images/downloadIcon.png" alt="" #tooltip="matTooltip"
              (touchstart)="tooltip.show()" (touchend)="tooltip.hide()" matTooltip="Click here to download E-Card"
              *ngIf="!isEcardDownloading" (click)="downloadECard()">
            <span *ngIf="isEcardDownloading" class="spinner" aria-hidden="true"></span>
            <a (click)="emailEcard(memberSelf)" href="#" data-toggle="modal" data-target="#view-print-claim"
              class="ecard-button" matTooltip="Click here to receive E-card to mail." matTooltipPosition="above">
              <img src="../../../../assets/images/shareIcon.png" alt="">
            </a>
          </div>
        </div>

        <div class="mid-bar">
          <div class="mid-bar-one">
            <div class="key">Health Coverage</div>
            <!-- <div class="value" *ngIf="family">₹  {{ family[0]?.healthSumInsured}}</div> -->
            <div class="value" *ngIf="family">₹2 Lakh</div>
            <div class="value skel" *ngIf="!family"> </div>

          </div>
          <div class="mid-bar-two">
            <div class="key">Accidental Death</div>
            <div class="value" *ngIf="family">₹10 Lakhs</div>
            <!-- <div class="value" *ngIf="family">₹ {{family[0]?.accidentalSumInsured}}</div>  -->
            <div class="value skel" *ngIf="!family"> </div>

          </div>
          <!-- <div class="mid-bar-three">
            <div class="key">OPD Coverage</div>
            <div class="value" *ngIf="family">₹ 10,000</div>
            <div class="value" *ngIf="family">₹ {{family[0]?.opdSumInsured}}</div>
            <div class="value skel" *ngIf="!family"> </div>

          </div> -->
          <!-- <div class="mid-bar-four">
            <div class="key">Validity Till</div>
            <div class="value"*ngIf="currentPolicy.riskEndDate" > {{currentPolicy.riskEndDate | date}} </div>
            <div class="value skel" *ngIf="!currentPolicy.riskEndDate"> </div>
          </div> -->
        </div>
      </div>


      <div class="low-bar">
        <div class="key">Members Covered</div>
        <div class="value">{{adultCount}} Adults, {{childrenCount}} Children</div>
      </div>


      <div class="zebu-bull">
        <img src="../../../../assets/images/zebuBull.png" alt="">
      </div>



    </div>
  </div>


  <div class="policy-benifits-container" (click)="navigateToPolicyCoverage()">
    <div class="policy-content">
      <div class="policy-icon">
        <img src="../../../../assets/images/policyBenifitsIcon.png" alt="">
      </div>
      <div class="policy-text">
        <div class="policy-text-heading">
          Policy Benefits
        </div>
        <div class="policy-text-content">
          View your policy benefits and coverage details.
        </div>
      </div>
    </div>
    <div class="arrow" style="margin: auto;">
      <img src="../../../../assets/images/arrow-right.png" alt="">
    </div>
  </div>

  <div class="network-hospitals-container" (click)="navigateToNetworkHospitals()">
    
      <div class="network-hospitals-content">
        <div>
          <img src="../../../../assets/images/network-hospitals-icon.png" alt="">
        </div>
        <div class="network-hospitals-text">
          <div class="network-hospitals-text-heading">
            10,000+ Hospitals
          </div>
          <div class="network-hospitals-text-content">
            Enjoy cashless treatment at our extensive hospital network. </div>
        </div>
      </div>

    <div class="arrow" style="margin: auto;" >
      <img src="../../../../assets/images/arrow-right.png" alt="">
    </div>

  </div>
</div>


<div class="modal fade" id="view-print-claim" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
  aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Send E-Card via E-mail</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="errorOccuredViaEmail=false">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <img src="../../../../assets/images/share-popup-image.png" alt="">
        <div class="text-center">
          <div *ngIf="isEmailSent" class="my-5">
            <h6 class="text-success">Email sent successfully.</h6>
          </div>
          <div *ngIf="!isEmailSent && errorOccuredViaEmail" class="my-5">
            <h6 class="text-danger">Error Occured.</h6>
          </div>
          <span *ngIf="isEmailSent !== null && !isEmailSent && !errorOccuredViaEmail"
            class="spinner-border text-secondary my-5" role="status" aria-hidden="true"></span>
        </div>

        <div class="form-group" *ngIf="isEmailSent === null && !isEmailSent">
          <label>Enter Email Id to get the e-card </label>
          <input type="text" class="form-control" [(ngModel)]="email" placeholder="Email"
            [value]="memberToEmail.emailID" (input)="emailInput($event)" />
        </div>
        <p *ngIf="invalidEmail" class="error-msg">
          <small>{{ invalidEmailMsg }}</small>
        </p>
      </div>
      <div class="modal-footer" *ngIf="isEmailSent === null && !isEmailSent">
        <button type="button" [disabled]="invalidEmail" (click)="emailSubmit()" class="btn btn-primary">
          Send
        </button>
      </div>
    </div>
  </div>
</div>